import * as React from 'react';
export const kakaoPaySvg = React.forwardRef(function kakaoPaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FFEB00',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M23 21H9a5 5 0 0 1 0-10h14a5 5 0 0 1 0 10Z',
      fill: '#000',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.615 13.4c-1.507 0-2.73.965-2.73 2.155 0 .765.507 1.437 1.267 1.82l-.258.96a.08.08 0 0 0 .02.083.078.078 0 0 0 .056.022.08.08 0 0 0 .048-.017l1.105-.747c.16.023.325.036.492.036 1.506 0 2.729-.965 2.729-2.155S11.122 13.4 9.614 13.4Z',
      fill: '#FFEB00',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.643 17.347v1.391h-.99v-5.133h.698l.122.326c.21-.21.53-.434 1.046-.434.972 0 1.433.726 1.426 1.9 0 1.23-.713 2.017-1.732 2.017-.196 0-.346-.013-.57-.067Zm0-2.914v2.22c.055.007.19.02.32.02.707 0 .978-.494.978-1.276 0-.685-.183-1.1-.746-1.1-.183 0-.389.055-.552.136Zm4.46.619h.563v-.122c0-.407-.231-.598-.632-.598a2.47 2.47 0 0 0-1.018.246l-.271-.666c.353-.245.895-.414 1.378-.414.95 0 1.466.502 1.466 1.46v2.356h-.699l-.102-.312c-.4.292-.767.414-1.1.414-.726 0-1.134-.434-1.134-1.168 0-.781.544-1.195 1.548-1.195v-.002Zm.563 1.31v-.68h-.455c-.509 0-.767.183-.767.55 0 .279.143.414.434.414.27 0 .619-.135.788-.285Zm3.924.57c-.345.923-.76 1.596-1.364 1.97l-.61-.564c.353-.306.604-.605.82-1.005l-1.317-3.591.984-.265.842 2.913.835-2.926.971.271-1.16 3.197Z',
      fill: '#FFEB00',
    }),
  );
});
kakaoPaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var kakaoPay = {
  category: 'brand',
  colorable: false,
  name: 'kakaoPay',
  svg: kakaoPaySvg,
};
